import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'icon-neft',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg
                width="24"
                height="24"
                viewBox="0 0 56 72"
                xmlns="http://www.w3.org/2000/svg"
                [ngClass]="class"
                aria-hidden="true"
            >
                <!-- Back banknote -->
                <rect x="10" y="5" width="32" height="16" rx="1.5" fill="#437E55" />

                <!-- Front banknote -->
                <rect x="14" y="9" width="32" height="16" rx="1.5" fill="#58B270" />

                <!-- Banknote ornament -->
                <rect x="20" y="13" width="20" height="8" rx="2" fill="#F9B948" />
                <circle cx="26" cy="17" r="1.6" fill="#FFFFFF" />
                <circle cx="30" cy="17" r="2.6" fill="#FFFFFF" />
                <circle cx="34" cy="17" r="1.6" fill="#FFFFFF" />

                <!-- Left transfer arrow -->
                <rect x="3" y="56" width="11" height="4" rx="0.5" fill="#E77D31" />
                <rect x="10" y="18" width="4" height="38" rx="0.5" fill="#E77D31" />
                <polygon fill="#E77D31" points="12,12 7,22 17,22" />

                <!-- Right transfer arrow -->
                <rect x="42" y="56" width="11" height="4" rx="0.5" fill="#E77D31" />
                <rect x="42" y="18" width="4" height="38" rx="0.5" fill="#E77D31" />
                <polygon fill="#E77D31" points="44,12 39,22 49,22" />

                <!-- Bank roof -->
                <polygon fill="#1C6091" points="28,37 16,49 40,49" />

                <!-- Bank header -->
                <rect x="15" y="49" width="26" height="3.5" rx="0.5" fill="#38B1D2" />

                <!-- Bank pillars -->
                <rect x="17.5" y="52.5" width="3.5" height="12" rx="0.5" fill="#246FB7" />
                <rect x="23" y="52.5" width="3.5" height="12" rx="0.5" fill="#246FB7" />
                <rect x="28.5" y="52.5" width="3.5" height="12" rx="0.5" fill="#246FB7" />
                <rect x="34" y="52.5" width="3.5" height="12" rx="0.5" fill="#246FB7" />

                <!-- Bank base -->
                <rect x="15" y="64.5" width="26" height="3.5" rx="0.5" fill="#38B1D2" />
            </svg>
        </ng-template>
    `,
})
export class IconNeftComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
